import { Stack, Typography, Box } from '@mui/material';
import { useClient } from '../../../../context/ClientContext';
import { ClientOptionButton } from '../../common/ClientOptionButton';
import StepsHeading from '../../common/StepsHeading';

export default function IsPregnant({ userData, setUserData, onNext }) {
  const { theme } = useClient();

  const handleOptionSelect = (field, value, idForPregnantField) => {
    setUserData(prev => ({
      ...prev,
      isPregnantId: idForPregnantField
  }));
    // Call onNext directly after selection to move to the next step
    onNext();
  };

  return (
    <Stack
      spacing={2}
      sx={{
        width: '100%',
        maxWidth: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden'
      }}
    >

      <StepsHeading title={"Are you pregnant or breastfeeding?"} />
      {[
        { label: "Yes, I am pregnant.", id: 1, value: true },
        { label: "Yes, I am breastfeeding.", id: 2, value: true },
        { label: "No", id: 3, value: false }
      ].map((option, index) => (
        <ClientOptionButton
          optionSelectSingleValue={userData.isPregnantId}  // Pass the current selected value
          value={option.id}  // Pass value to compare with userData
          key={index}
          option={option.label}
          onClick={() => handleOptionSelect('isPregnant', option.value, option.id)}
        />
      ))}
    </Stack>
  );
}